import { calenderAction } from "../redux/reducer/calenderReducer";


export const ScheduleStatus = Object.freeze({
     ACTIVE:'ACTIVE',
    PENDING:'PENDING',
    DELETE:'IN-ACTIVE',
    CANCELED:'CANCELED'
})

export const checkSlot = (startDate, endDate, courtNumber, id, scheduleRef) => {
    let schedules = scheduleRef.current.getCurrentViewEvents();
    const events = schedules.filter(event => event.CourtNumber === courtNumber && event.Id !== id);
   
    for (let i = 0; i < events.length; i++) {
        const eventStart = events[i].StartTime;
        const eventEnd = events[i].EndTime;

        if (eventStart.getTime() + 10 <= startDate.getTime() && eventEnd.getTime() - 10 >= endDate.getTime()) {
            return false;
        }
        if (eventStart.getTime() + 10 <= endDate.getTime() && eventEnd.getTime() - 10 >= endDate.getTime()) {
            return false;
        }
        if (eventStart.getTime() + 10 <= startDate.getTime() && eventEnd.getTime() - 10 >= startDate.getTime()) {
            return false;
        }
        if (eventStart.getTime() + 10 > startDate.getTime() && eventEnd.getTime() - 10 < endDate.getTime()) {
            return false;
        }
    }
    return true;
}
export const checkSlotForCreateReservation = (startTime, endTime, courtNumber, id, scheduleRef) => {
    let startDate = new Date(new Date(startTime).toLocaleString("en-US", { timeZone: 'UTC' }));
    let endDate = new Date(new Date(endTime).toLocaleString("en-US", { timeZone: 'UTC' }));
    let schedules = scheduleRef.current.getCurrentViewEvents();
    const events = schedules.filter(event => event.CourtNumber === courtNumber && event.Id !== id);

    for (let i = 0; i < events.length; i++) {
        const eventStart = events[i].StartTime;
        const eventEnd = events[i].EndTime;

        if (eventStart.getTime() + 10 <= startDate.getTime() && eventEnd.getTime() - 10 >= endDate.getTime()) {
            return false;
        }
        if (eventStart.getTime() + 10 <= endDate.getTime() && eventEnd.getTime() - 10 >= endDate.getTime()) {
            return false;
        }
        if (eventStart.getTime() + 10 <= startDate.getTime() && eventEnd.getTime() - 10 >= startDate.getTime()) {
            return false;
        }
        if (eventStart.getTime() + 10 > startDate.getTime() && eventEnd.getTime() - 10 < endDate.getTime()) {
            return false;
        }
    }

    return true;
}

//Get selected date data and set in state
export const getCurrentDate = (scheduleRef, dispatch) => {
    if (scheduleRef.current) {
        let currTime = scheduleRef.current.getCurrentViewDates();
        if (currTime !== undefined && currTime.length != 0) {
            const startTime = currTime[0]?.setHours(0, 0, 0, 0);
            const endTime = currTime[0]?.setHours(23, 59, 59, 999) + 1000;
            dispatch(calenderAction.setDayStartTime(startTime));
            dispatch(calenderAction.setDayEndTime(endTime));
            return {
                startTime: startTime,
                endTime: endTime
            }
        }
    }
};
//Get selected date range data and set in state
export const getCurrentDateByWeek = (scheduleRef, dispatch) => {
    if (scheduleRef && scheduleRef.current) {
        let currTime = scheduleRef.current.getCurrentViewDates();
        if (currTime !== undefined && currTime.length != 0) {
            const startTime = currTime[0]?.setHours(0, 0, 0, 0);
            const endTime = currTime[currTime.length - 1]?.setHours(23, 59, 59, 999) + 1000;
            dispatch(calenderAction.setWeekDayStartTime(startTime));
            dispatch(calenderAction.setWeekDayEndTime(endTime));
            return {
                startTime: startTime,
                endTime: endTime
            }
        }
    }
    
};
//Get current view data and set in state
export const getCurrentView = (scheduleRef, dispatch) => {
    if (scheduleRef && scheduleRef.current) {
        dispatch(calenderAction.setCurrentView(scheduleRef.current?.currentView));
    }
}
export const handleTimeOparetionsPerDay = (scheduleRef, dispatch, calenderConfig) => {
    let currTime = scheduleRef.current?.getCurrentViewDates();
    let result;
    if (!currTime) {
        return;
    }
    let data = calenderConfig.workingDays;
    data.forEach((data) => {
        if (currTime[0]?.getDay() == data.day) {
            dispatch(calenderAction.setStartHour(data.startHour));
            dispatch(calenderAction.setEndHour(data.endHour));
            result ={
                startHour:data.startHour,
                endHour:data.endHour
            }
        }
    })
    return result;
}
export const getMaximunmTimeInADay = (dispatch, calenderConfig) => {

    let data = calenderConfig.workingDays;
    let minimum = data.reduce((min, item) => (item.startHour < min.startHour ? item : min), data[0]);
    let maximum = data.reduce((max, item) => (item.endHour < max.endHour ? max : item), data[0]);

    dispatch(calenderAction.setStartHour(minimum.startHour));
    dispatch(calenderAction.setEndHour(maximum.endHour));
    return {
        startHour: minimum.startHour,
        endHour: maximum.endHour
    }
}
export const createWorkingDays = (calenderConfig) => {
    let result = [];
    let data = calenderConfig.workingDays;
    data.forEach((data) => {
        result.push(data.day);
    })
    return result;
}
export const setInitialStartAndEndHour = (dispatch, calenderConfig,isUser) => {
    let data = calenderConfig.workingDays;
    let initialValue;
    let currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: calenderConfig.calenderTimezone }));

    let currentDay = currentDate.getDay();
    for (let i = 0; i < 7; i++) {
        initialValue = data.find((item) => item.day == currentDay);
        if (initialValue) {
            break;
        }
        else {
            if (currentDay == 6) {
                currentDay = 0;
                let nextDate = new Date(currentDate);
                currentDate = new Date(nextDate.setDate(currentDate.getDate() + 1));
            }
            else {
                currentDay++;
                let nextDate = new Date(currentDate);
                currentDate = new Date(nextDate.setDate(currentDate.getDate() + 1));

            }
        }
    }
    dispatch(calenderAction.setStartHour(initialValue?.startHour));
    dispatch(calenderAction.setEndHour(initialValue?.endHour));
    dispatch(calenderAction.setDayStartTime(new Date(currentDate.setHours(0, 0, 0, 0)).getTime()))
    //if (isUser){
        const targetDate = new Date(currentDate);
        targetDate.setDate(targetDate.getDate() + 7);
        targetDate.setHours(23, 59, 59, 999);
        dispatch(calenderAction.setWeekDayStartTime(new Date(currentDate.setHours(0, 0, 0, 0)).getTime()))
        dispatch(calenderAction.setWeekDayEndTime(targetDate.getTime()))
   // }else{
        dispatch(calenderAction.setDayEndTime(new Date(currentDate.setHours(23, 59, 59, 999)).getTime() + 1))
   // }
    

    return {
        startHour: initialValue?.startHour,
        endHour: initialValue?.endHour,
        dayStartTime: new Date(currentDate.setHours(0, 0, 0, 0)).getTime(),
        dayEndTime: new Date(currentDate.setHours(23, 59, 59, 999)).getTime() + 1
    }
}
const toMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
};
export const isAllDayAvailable = (startTime, endTime, calenderConfig)=>{
    let UTCStartTime = new Date(new Date(startTime).toLocaleString("en-US", { timeZone: "UTC" }));
    let UTCEndTime = new Date(new Date(endTime).toLocaleString("en-US", { timeZone: "UTC" }));
    let currDate = new Date().toLocaleString("en-US", { timeZone: calenderConfig.calenderTimezone });
    if (((UTCStartTime - new Date(currDate)) / (1000 * 60 * 60)) <= 1){
        return true;
    }
    return false;
}
export const checkSlotOpenOrCloseForSaveReservation = (startTime, endTime, calenderConfig) => {
    let start = null;
    let end = null;
    let checkStart = null;
    let checkEnd = null;
    let status = false;
    let data = calenderConfig.workingDays;
    let UTCStartTime = new Date(new Date(startTime).toLocaleString("en-US", { timeZone: "UTC" }));
    let UTCEndTime = new Date(new Date(endTime).toLocaleString("en-US", { timeZone: "UTC" }));
    
    data.forEach((item) => {
        if (item.day == UTCStartTime.getDay()) {
            start = toMinutes(item.startHour);
            end = toMinutes(item.endHour);
            checkStart = (UTCStartTime.getHours() * 60) + UTCStartTime.getMinutes();
            checkEnd = (UTCEndTime.getHours() * 60) + UTCEndTime.getMinutes();
            if (item.day != UTCEndTime.getDay() || item.day != UTCStartTime.getDay()) {
                status = true;
            }
        }
    });
    if (status) {
        return false;
    }
    
    if (checkStart !== null && start !== null && end !== null) {
        if (checkStart > start && checkStart < end && checkEnd > end) {
            return false;
        } else {
            return true;
        }
    }

}
export const checkSlotOpenOrClose = (startTime, calenderConfig) => {
    let start = null;
    let end = null;
    let check = null;
    let data = calenderConfig.workingDays;

    data.forEach((item) => {
        if (item.day == startTime.getDay()) {
            start = toMinutes(item.startHour);
            end = toMinutes(item.endHour);
            check = (startTime.getHours() * 60) + startTime.getMinutes();
        }
    });

    if (check !== null && start !== null && end !== null) {
        if (check >= start && check <= end) {
            return false;
        } else {
            return true;
        }
    }

}

export function validateTimesWithDetails(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);

    if (isNaN(start.getTime())) return "Invalid start time format";
    if (isNaN(end.getTime())) return "Invalid end time format";
    if (start.getTime() === end.getTime()) return "Times cannot be identical";
    if (end.getTime() < start.getTime()) return "End time cannot be before start time";

    return null; // No error
}
